import { jsx } from "react/jsx-runtime";
import { ContentType } from "../../../enums/contentStack.js";
import { findOneBusinessEntry, findOneBusinessEntryWhere, getConfigurationSettingByDeveloperKey, DEFAULT_FIELD_EXCEPTIONS } from "../../../services/content/business.lib.js";
import { SystemDefinedLinkUI } from "./SystemDefinedLinkUI.js";
import { DEVELOPMENT_KEY_MAP } from "./constants.js";
async function SystemDefinedLink({
  dataTestId = "",
  enableLivePreview,
  entryId,
  linkStyle,
  linkType,
  locale
}) {
  let entry, moduleSettings;
  if (entryId) {
    entry = await findOneBusinessEntry(
      ContentType.SystemDefinedLink,
      entryId,
      locale
    );
  } else if (linkType) {
    entry = await findOneBusinessEntryWhere(
      ContentType.SystemDefinedLink,
      "link_type",
      linkType,
      locale
    );
  } else {
    console.log(`SystemDefinedLink error: entryId or linkType required`);
    return null;
  }
  if (!entry) {
    console.log(
      `SystemDefinedLink error: could not find entry with id: ${entryId} or linkType: ${linkType}`
    );
    return null;
  }
  const developmentKey = DEVELOPMENT_KEY_MAP[entry.link_type];
  if (developmentKey) {
    moduleSettings = await getConfigurationSettingByDeveloperKey(
      ContentType.ModuleSettings,
      developmentKey,
      entry.locale,
      DEFAULT_FIELD_EXCEPTIONS,
      enableLivePreview
    );
  }
  return /* @__PURE__ */ jsx(
    SystemDefinedLinkUI,
    {
      dataTestId,
      entry,
      linkStyle,
      locale,
      moduleSettings
    }
  );
}
export {
  SystemDefinedLink
};
